import { render, staticRenderFns } from "./DomainSummary.vue?vue&type=template&id=0e07f184&scoped=true&"
import script from "./DomainSummary.vue?vue&type=script&lang=js&"
export * from "./DomainSummary.vue?vue&type=script&lang=js&"
import style0 from "./DomainSummary.vue?vue&type=style&index=0&id=0e07f184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e07f184",
  null
  
)

export default component.exports